import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { SideNav } from '@servicetitan/design-system';
import { getNavClickHandler } from '../../utils/get-nav-click-handler';

interface SideNavLinkProps {
    to: string;
    name: string;
}

export const SideNavLink: FC<SideNavLinkProps> = ({ to, name }) => (
    <NavLink to={to}>
        {({ isActive }) => (
            <SideNav.Item active={isActive} onClick={getNavClickHandler(isActive)}>
                {name}
            </SideNav.Item>
        )}
    </NavLink>
);
